import { render, staticRenderFns } from "./aiLab.vue?vue&type=template&id=24fff483&scoped=true&"
import script from "./aiLab.vue?vue&type=script&lang=js&"
export * from "./aiLab.vue?vue&type=script&lang=js&"
import style0 from "./aiLab.vue?vue&type=style&index=0&id=24fff483&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fff483",
  null
  
)

export default component.exports